import { Distrct, States } from "app/config/administrativeConstants";

export const REQUIRED_FIELDS = [
  "studentAdmissionType",
  "firstName",
  "className",
  "stream",
  "section",
  "community",
  "fatherInfo.firstName",
  "motherInfo.firstName",
  "currentAddress.state",
  "currentAddress.dist",
  "currentAddress.pinCode",
  "currentAddress.address",
  "mobileNumber",
  "admissionDate",
];

export const DATE_FIELDS = ["firstAdmissionDate", "admissionDate", "DOB"];

export const DROPDOWN_FIELDS = [
  "studentAdmissionType",
  "gender",
  "community",
  "category",
  "currentAddress.state",
  "currentAddress.dist",
];

export const getDropdownOptions = (columnKey, selectedState) => {
  switch (columnKey) {
    case "studentAdmissionType":
      return ["oldStudent", "newStudent"];
    case "gender":
      return ["Male", "Female", "Other"];
    case "community":
      return ["Hindu", "Islam", "Christian", "Sikh", "Other"];
    case "category":
      return ["General", "OBC", "SC", "ST", "Other"];
    case "currentAddress.state":
      return States;
    case "currentAddress.dist":
      return Distrct[States.indexOf(selectedState) + 1] || [];
    default:
      return [];
  }
};

export const ADMISSION_SUCCESS_COLUMNS = [
  "S.No",
  "Adm No",
  "S.Name",
  "Class",
  "F.Name",
];

export const ADMISSION_FAILED_COLUMNS = ["S.No", "Student", "Class", "Reason"];

export const TRANSPORT_SUCCESS_COLUMNS = [
  "S.No",
  "Adm No",
  "Fee Amount",
  "R.No",
  "V.Number",
];

export const TRANSPORT_FAILED_COLUMNS = ["S.No", "Student", "Class", "Reason"];

export const ACCEPTED_UPLOAD_FORMATS = [".xlsx", ".xls", ".csv"];

export const ACCEPTED_UPLOAD_ACCEPT = ACCEPTED_UPLOAD_FORMATS.join(",");
